import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { ImportInfoData } from "../../../models/ImportInfoData";
import { ImportPortefeuille } from "../../../models/ImportPortefeuille";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "../../../services/fonds-propres.service";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-view-item-modal",
  templateUrl: "./view-item-modal.component.html",
  styleUrls: ["./view-item-modal.component.scss"],
})
export class ViewItemModalComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ImportInfoData>;
  isLoadingResults = false;

  displayedColumns = ["category", "codeDossier", "typeInfo", "content"];
  data: ImportInfoData[] = [];

  //From Modal:  parameters
  portefeuille: ImportPortefeuille;

  constructor(
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.getImportInfoDatasByImportPortefeuilleId(this.portefeuille.id);
  }

  getImportInfoDatasByImportPortefeuilleId(importPortefeuilleId: number) {
    this.isLoadingResults = true;
    this.shared
      .getImportInfoDatasByImportPortefeuilleId(importPortefeuilleId)
      .subscribe(
        (data) => {
          this.data = data;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        },
        () => {
          if (this.data == null) {
            this.data = [];
          }
          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.isLoadingResults = false;
        }
      );
  }
}
